import React from 'react'

interface PremiumButtonProps {
  children: React.ReactNode
  onClick?: () => void
  variant?: 'primary' | 'secondary' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
}

export default function PremiumButton({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'right',
}: PremiumButtonProps) {
  const baseStyles =
    'inline-flex items-center justify-center gap-2 font-medium transition-all duration-300 cursor-pointer select-none'

  const sizeStyles = {
    sm: 'px-5 py-2.5 text-sm rounded-xl',
    md: 'px-7 py-3.5 text-base rounded-2xl',
    lg: 'px-10 py-4 text-lg rounded-2xl',
  }

  const variantStyles = {
    primary:
      'bg-gradient-to-br from-[#F97316] to-[#EA580C] text-white shadow-lg hover:shadow-xl hover:shadow-orange-500/30 hover:-translate-y-0.5 active:translate-y-0',
    secondary:
      'bg-white text-[#F97316] border-2 border-[#F97316] hover:bg-orange-50 hover:-translate-y-0.5 active:translate-y-0 shadow-md hover:shadow-lg',
    ghost: 'text-gray-700 hover:text-[#F97316] hover:bg-orange-50 rounded-xl',
  }

  return (
    <button className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]}`} onClick={onClick}>
      {icon && iconPosition === 'left' && (
        <span className="transition-transform duration-300 group-hover:scale-110">{icon}</span>
      )}
      {children}
      {icon && iconPosition === 'right' && (
        <span className="transition-transform duration-300 group-hover:translate-x-1">{icon}</span>
      )}
    </button>
  )
}
